function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.343 3.344A8 8 0 009 17M14.657 14.657A8 8 0 009 1",
  stroke: "#B0B8CE",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64 5.1V3.046H1.587M16.254 15.123h-2.052V13.07M10.787 12.022a1.866 1.866 0 10-3.732 0 1.866 1.866 0 003.732 0zM8.92 10.157V3.684M8.92 7.172h1.993M10.913 5.18H8.92",
  stroke: "#B0B8CE",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

function SvgChangePw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgChangePw;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ChangePW.svg
// module id = 1321
// module chunks = 10